import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

function FAQ() {
	return (
		<>
			<Helmet>
				<title>FAQ | Apex Specialty Contracting LLC – Roofing Questions Answered</title>
				<meta name="description" content="Frequently asked questions about roofing replacement, storm damage repair, insurance claims, and our SMS messaging program. Tarpon Springs, FL. Call (916) 316-0696." />
			</Helmet>
			<PageHeader title="Frequently Asked Questions" subtitle="Your roofing questions answered — from inspections and insurance to materials and messaging." />
			<section className="section">
				<div className="container">
					<h2>Roofing Questions</h2>
					<div className="grid" style={{ marginTop: 16 }}>
						<div className="card" style={{ padding: 20 }}>
							<strong>How do I know if I need a full roof replacement or just a repair?</strong>
							<p className="helper">Our certified inspectors will assess your roof's age, condition, and damage extent. As a general rule, if your roof is 15+ years old or more than 30% of the surface is damaged, replacement is often the most cost-effective solution. We'll give you an honest recommendation — no upselling.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>How long does a roof replacement take?</strong>
							<p className="helper">Most residential roof replacements are completed in 1–2 days, depending on the size and complexity of the roof. We'll give you a realistic timeline upfront and keep you updated at every milestone via SMS.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>What roofing materials do you offer?</strong>
							<p className="helper">We install asphalt shingles (3-tab and architectural), metal roofing (standing seam and corrugated), concrete and clay tile, and flat roofing systems (TPO, EPDM, modified bitumen). We'll help you choose the best option for your home's style, budget, and Florida's climate.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>Do you offer free inspections?</strong>
							<p className="helper">Yes. We provide free, no-obligation roof inspections. Our inspector will examine every component—shingles, flashing, gutters, vents—and provide a detailed written report. There is no pressure to hire us.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>Are you licensed and insured in Florida?</strong>
							<p className="helper">Yes. APEX SPECIALTY CONTRACTING LLC holds a Florida Roofing Contractor License and carries $2,000,000 in general liability insurance plus full workers' compensation coverage. We provide certificates of insurance upon request.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>What warranty comes with my new roof?</strong>
							<p className="helper">Every installation includes a manufacturer's material warranty (25 years to lifetime coverage depending on product) plus our own <strong>5-year workmanship warranty</strong>. If any issue results from our installation, we return and fix it at no cost.</p>
						</div>
					</div>

					<h2 style={{ marginTop: 40 }}>Storm Damage &amp; Insurance</h2>
					<div className="grid" style={{ marginTop: 16 }}>
						<div className="card" style={{ padding: 20 }}>
							<strong>My roof was damaged in a storm. What should I do first?</strong>
							<p className="helper">Call us as soon as possible at (916) 316-0696. We will schedule an emergency inspection, document all damage with photographs and detailed reports, and install an emergency tarp if needed to prevent further water intrusion. Do not delay — insurance claims have deadlines.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>Can you help me with my insurance claim?</strong>
							<p className="helper">Absolutely. We work directly with your insurance adjuster, provide comprehensive damage documentation, and can meet the adjuster on-site. We prepare Xactimate-compatible estimates and support supplement requests if the initial settlement is insufficient to cover the cost of proper repairs.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>Do you charge for insurance claim assistance?</strong>
							<p className="helper">No. Insurance claim support is included as part of our service when we are performing the repairs or replacement. We are not a public adjuster and do not charge a percentage of your claim.</p>
						</div>
					</div>

					<h2 style={{ marginTop: 40 }}>SMS &amp; Communication</h2>
					<div className="grid" style={{ marginTop: 16 }}>
						<div className="card" style={{ padding: 20 }}>
							<strong>How do I stop receiving text messages?</strong>
							<p className="helper">Reply <strong>STOP</strong> to any text message we send and you will be immediately unsubscribed. You can also visit our <a href="/opt-out">Opt-Out page</a> or email <a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a>.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>What types of text messages will I receive?</strong>
							<p className="helper">If you opt in, you may receive estimate follow-ups, appointment reminders, project milestone updates, and occasional promotional offers. Message frequency varies. Msg &amp; data rates may apply.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>Is my consent required to receive roofing services?</strong>
							<p className="helper">No. SMS consent is entirely optional. You can request a free estimate, schedule an inspection, and hire us without ever opting in to receive text messages.</p>
						</div>
						<div className="card" style={{ padding: 20 }}>
							<strong>How is my information used?</strong>
							<p className="helper">Your contact information is used solely to communicate with you about your roofing project and requests. We do not sell your personal data to third parties. See our <a href="/privacy">Privacy Policy</a> for full details.</p>
						</div>
					</div>

					<div className="card" style={{ padding: 24, marginTop: 32, textAlign: 'center' }}>
						<h3>Still have questions?</h3>
						<p className="helper">Our team is happy to help. Call us, email us, or request a free estimate.</p>
						<div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap', marginTop: 14 }}>
							<Link className="btn" to="/contact">Get a Free Estimate</Link>
							<a className="btn-outline" href="tel:9163160696">Call (916) 316-0696</a>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default FAQ;
